import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

// Reset browser defaults
const style = document.createElement('style');
style.textContent = `
  * { margin: 0; padding: 0; box-sizing: border-box; }
  body { background: #0f0f17; color: #e8e8f0; }
  ::-webkit-scrollbar { width: 6px; }
  ::-webkit-scrollbar-track { background: #0f0f17; }
  ::-webkit-scrollbar-thumb { background: #2a2a3a; border-radius: 3px; }
  input, select, textarea { outline: none; }
  input::placeholder, textarea::placeholder { color: #3a3a4a; }
`;
document.head.appendChild(style);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);
